export const MOCK_COST_DATA = {
  summary: {
    total_cost_usd: 14.0,
    trace_count: 848,
    avg_cost_per_trace_usd: 0.016509,
    previous_total_cost_usd: 11.2,
    delta_cost_usd: 2.8,
    delta_cost_pct: 25.0,
  },
  workflow_cost_breakdown: [
    {
      key: 'customer_support',
      label: 'customer_support',
      total_cost_usd: 7.89,
      trace_count: 520,
      avg_cost_per_trace_usd: 0.015173,
      previous_total_cost_usd: 6.5,
      delta_cost_usd: 1.39,
      delta_cost_pct: 21.38,
      prompt_tokens: 1050000,
      completion_tokens: 312000,
      cached_tokens: 0,
      total_tokens: 1362000,
      share_of_spend_pct: 56.36,
    },
    {
      key: 'order_lookup',
      label: 'order_lookup',
      total_cost_usd: 4.4556,
      trace_count: 320,
      avg_cost_per_trace_usd: 0.013924,
      previous_total_cost_usd: null,
      delta_cost_usd: null,
      delta_cost_pct: null,
      prompt_tokens: 600000,
      completion_tokens: 180000,
      cached_tokens: 0,
      total_tokens: 780000,
      share_of_spend_pct: 31.83,
    },
    {
      key: 'vip_escalation',
      label: 'vip_escalation',
      total_cost_usd: 1.6544,
      trace_count: 8,
      avg_cost_per_trace_usd: 0.2068,
      previous_total_cost_usd: 0.8,
      delta_cost_usd: 0.8544,
      delta_cost_pct: 106.8,
      prompt_tokens: 121000,
      completion_tokens: 41000,
      cached_tokens: 0,
      total_tokens: 162000,
      share_of_spend_pct: 11.81,
    },
  ],
  agent_cost_breakdown: [
    {
      key: 'agent:ChatCompletion',
      label: 'ChatCompletion',
      filterValue: 'ChatCompletion',
      total_cost_usd: 5.44,
      trace_count: null,
      avg_cost_per_trace_usd: null,
      previous_total_cost_usd: null,
      delta_cost_usd: null,
      delta_cost_pct: null,
      prompt_tokens: 245200,
      completion_tokens: 35600,
      cached_tokens: 0,
      total_tokens: 280800,
      share_of_spend_pct: 81.07,
    },
    {
      key: 'agent:RetrievalAgent',
      label: 'RetrievalAgent',
      filterValue: 'RetrievalAgent',
      total_cost_usd: 0.9,
      trace_count: null,
      avg_cost_per_trace_usd: null,
      previous_total_cost_usd: null,
      delta_cost_usd: null,
      delta_cost_pct: null,
      prompt_tokens: 63700,
      completion_tokens: 2600,
      cached_tokens: 0,
      total_tokens: 66300,
      share_of_spend_pct: 13.41,
    },
    {
      key: 'agent:ValidationAgent',
      label: 'ValidationAgent',
      filterValue: 'ValidationAgent',
      total_cost_usd: 0.37,
      trace_count: null,
      avg_cost_per_trace_usd: null,
      previous_total_cost_usd: null,
      delta_cost_usd: null,
      delta_cost_pct: null,
      prompt_tokens: 23700,
      completion_tokens: 2600,
      cached_tokens: 0,
      total_tokens: 26300,
      share_of_spend_pct: 5.51,
    },
  ],
  model_cost_breakdown: [
    {
      key: 'model:openai:gpt-4o',
      label: 'openai / gpt-4o',
      filterValue: 'gpt-4o',
      total_cost_usd: 6.02,
      trace_count: null,
      avg_cost_per_trace_usd: null,
      previous_total_cost_usd: null,
      delta_cost_usd: null,
      delta_cost_pct: null,
      prompt_tokens: 208500,
      completion_tokens: 31700,
      cached_tokens: 0,
      total_tokens: 240200,
      share_of_spend_pct: 89.72,
    },
    {
      key: 'model:openai:gpt-4o-mini',
      label: 'openai / gpt-4o-mini',
      filterValue: 'gpt-4o-mini',
      total_cost_usd: 0.69,
      trace_count: null,
      avg_cost_per_trace_usd: null,
      previous_total_cost_usd: null,
      delta_cost_usd: null,
      delta_cost_pct: null,
      prompt_tokens: 126800,
      completion_tokens: 11000,
      cached_tokens: 0,
      total_tokens: 137800,
      share_of_spend_pct: 10.28,
    },
  ],
  model_cost_over_time: [
    { timestamp: '2026-02-26T00:00:00Z', models: [{ model_name: 'gpt-4o', provider: 'openai', cost_usd: 0.82, total_tokens: 32400, prompt_tokens: 28100, completion_tokens: 4300, cached_tokens: 0 }, { model_name: 'gpt-4o-mini', provider: 'openai', cost_usd: 0.09, total_tokens: 18200, prompt_tokens: 16800, completion_tokens: 1400, cached_tokens: 0 }] },
    { timestamp: '2026-02-27T00:00:00Z', models: [{ model_name: 'gpt-4o', provider: 'openai', cost_usd: 0.74, total_tokens: 29800, prompt_tokens: 25900, completion_tokens: 3900, cached_tokens: 0 }, { model_name: 'gpt-4o-mini', provider: 'openai', cost_usd: 0.08, total_tokens: 16400, prompt_tokens: 15100, completion_tokens: 1300, cached_tokens: 0 }] },
    { timestamp: '2026-02-28T00:00:00Z', models: [{ model_name: 'gpt-4o', provider: 'openai', cost_usd: 0.91, total_tokens: 36200, prompt_tokens: 31400, completion_tokens: 4800, cached_tokens: 0 }, { model_name: 'gpt-4o-mini', provider: 'openai', cost_usd: 0.11, total_tokens: 21600, prompt_tokens: 19900, completion_tokens: 1700, cached_tokens: 0 }] },
    { timestamp: '2026-03-01T00:00:00Z', models: [{ model_name: 'gpt-4o', provider: 'openai', cost_usd: 0.68, total_tokens: 27100, prompt_tokens: 23500, completion_tokens: 3600, cached_tokens: 0 }, { model_name: 'gpt-4o-mini', provider: 'openai', cost_usd: 0.07, total_tokens: 14800, prompt_tokens: 13600, completion_tokens: 1200, cached_tokens: 0 }] },
    { timestamp: '2026-03-02T00:00:00Z', models: [{ model_name: 'gpt-4o', provider: 'openai', cost_usd: 1.23, total_tokens: 49100, prompt_tokens: 42600, completion_tokens: 6500, cached_tokens: 0 }, { model_name: 'gpt-4o-mini', provider: 'openai', cost_usd: 0.15, total_tokens: 29800, prompt_tokens: 27400, completion_tokens: 2400, cached_tokens: 0 }] },
    { timestamp: '2026-03-03T00:00:00Z', models: [{ model_name: 'gpt-4o', provider: 'openai', cost_usd: 0.88, total_tokens: 35200, prompt_tokens: 30600, completion_tokens: 4600, cached_tokens: 0 }, { model_name: 'gpt-4o-mini', provider: 'openai', cost_usd: 0.10, total_tokens: 19800, prompt_tokens: 18200, completion_tokens: 1600, cached_tokens: 0 }] },
    { timestamp: '2026-03-04T00:00:00Z', models: [{ model_name: 'gpt-4o', provider: 'openai', cost_usd: 0.76, total_tokens: 30400, prompt_tokens: 26400, completion_tokens: 4000, cached_tokens: 0 }, { model_name: 'gpt-4o-mini', provider: 'openai', cost_usd: 0.09, total_tokens: 17200, prompt_tokens: 15800, completion_tokens: 1400, cached_tokens: 0 }] },
  ],
  agent_cost_over_time: [
    { timestamp: '2026-02-26T00:00:00Z', agents: [{ agent_name: 'ChatCompletion', cost_usd: 0.74, total_tokens: 38200, prompt_tokens: 33400, completion_tokens: 4800, cached_tokens: 0 }, { agent_name: 'RetrievalAgent', cost_usd: 0.12, total_tokens: 8900, prompt_tokens: 8600, completion_tokens: 300, cached_tokens: 0 }, { agent_name: 'ValidationAgent', cost_usd: 0.05, total_tokens: 3500, prompt_tokens: 3200, completion_tokens: 300, cached_tokens: 0 }] },
    { timestamp: '2026-02-27T00:00:00Z', agents: [{ agent_name: 'ChatCompletion', cost_usd: 0.67, total_tokens: 34600, prompt_tokens: 30200, completion_tokens: 4400, cached_tokens: 0 }, { agent_name: 'RetrievalAgent', cost_usd: 0.11, total_tokens: 8100, prompt_tokens: 7800, completion_tokens: 300, cached_tokens: 0 }, { agent_name: 'ValidationAgent', cost_usd: 0.04, total_tokens: 3100, prompt_tokens: 2800, completion_tokens: 300, cached_tokens: 0 }] },
    { timestamp: '2026-02-28T00:00:00Z', agents: [{ agent_name: 'ChatCompletion', cost_usd: 0.82, total_tokens: 42400, prompt_tokens: 37000, completion_tokens: 5400, cached_tokens: 0 }, { agent_name: 'RetrievalAgent', cost_usd: 0.14, total_tokens: 10200, prompt_tokens: 9800, completion_tokens: 400, cached_tokens: 0 }, { agent_name: 'ValidationAgent', cost_usd: 0.06, total_tokens: 4100, prompt_tokens: 3700, completion_tokens: 400, cached_tokens: 0 }] },
    { timestamp: '2026-03-01T00:00:00Z', agents: [{ agent_name: 'ChatCompletion', cost_usd: 0.61, total_tokens: 31600, prompt_tokens: 27600, completion_tokens: 4000, cached_tokens: 0 }, { agent_name: 'RetrievalAgent', cost_usd: 0.10, total_tokens: 7400, prompt_tokens: 7100, completion_tokens: 300, cached_tokens: 0 }, { agent_name: 'ValidationAgent', cost_usd: 0.04, total_tokens: 2900, prompt_tokens: 2600, completion_tokens: 300, cached_tokens: 0 }] },
    { timestamp: '2026-03-02T00:00:00Z', agents: [{ agent_name: 'ChatCompletion', cost_usd: 1.11, total_tokens: 57400, prompt_tokens: 50100, completion_tokens: 7300, cached_tokens: 0 }, { agent_name: 'RetrievalAgent', cost_usd: 0.19, total_tokens: 13800, prompt_tokens: 13300, completion_tokens: 500, cached_tokens: 0 }, { agent_name: 'ValidationAgent', cost_usd: 0.08, total_tokens: 5600, prompt_tokens: 5000, completion_tokens: 600, cached_tokens: 0 }] },
    { timestamp: '2026-03-03T00:00:00Z', agents: [{ agent_name: 'ChatCompletion', cost_usd: 0.80, total_tokens: 41200, prompt_tokens: 36000, completion_tokens: 5200, cached_tokens: 0 }, { agent_name: 'RetrievalAgent', cost_usd: 0.13, total_tokens: 9600, prompt_tokens: 9200, completion_tokens: 400, cached_tokens: 0 }, { agent_name: 'ValidationAgent', cost_usd: 0.05, total_tokens: 3800, prompt_tokens: 3400, completion_tokens: 400, cached_tokens: 0 }] },
    { timestamp: '2026-03-04T00:00:00Z', agents: [{ agent_name: 'ChatCompletion', cost_usd: 0.69, total_tokens: 35400, prompt_tokens: 30900, completion_tokens: 4500, cached_tokens: 0 }, { agent_name: 'RetrievalAgent', cost_usd: 0.11, total_tokens: 8300, prompt_tokens: 7900, completion_tokens: 400, cached_tokens: 0 }, { agent_name: 'ValidationAgent', cost_usd: 0.05, total_tokens: 3300, prompt_tokens: 3000, completion_tokens: 300, cached_tokens: 0 }] },
  ],
};
